import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { AccountState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: AccountState = {
  tyc: 0,
  aceptar_tyc: true,
  correo: '',
  alerta_correo: '',
  access_token: '',
  id: 1,
  alerta_movil: '',
  region_list: [],
  passwordUpdate: {
    status: 200,
    timestamp: 0
  },
  alertUpdate: {
    status: 200,
    timestamp: 0
  },
  error: { state: false }
}

const namespaced: boolean = true

export const account: Module<AccountState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
